import PropTypes from 'prop-types';
import React from 'react';

function PrivacySettings(props){
  return (
    <h1>Privacy Settings</h1>
  )
}

export default PrivacySettings;